
import { Country, Package, BlogPost, Service } from './types';

export const COUNTRIES: Country[] = [
  {
    id: '1',
    name: 'Apvienotie Arābu Emirāti',
    slug: 'apvienotie-arabu-emirati',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=1200&auto=format&fit=crop',
    description: 'Apvienotie Arābu Emirāti ir vieta, kur nākotne satiekas ar tradīcijām. Šis galamērķis ir kļuvis par sinonīmu nepieredzētai greznībai, arhitektūras brīnumiem un pasaules līmeņa izklaidei. No Dubaijas mirdzošajiem debesskrāpjiem līdz Abu Dabī mierīgajām mošejām un tuksneša safāri piedzīvojumiem – AAE piedāvā kaut ko ikvienam ceļotājam.',
    highlights: ['Pasaulē augstākās celtnes', 'Grezni iepirkšanās centri', 'Tuksneša safāri', 'Mākslīgās salas'],
    cities: [{ id: '101', name: 'Dubaija', slug: 'dubaija', countryId: '1' }]
  },
  {
    id: '2',
    name: 'Bulgārija',
    slug: 'bulgarija',
    image: 'https://images.unsplash.com/photo-1489743342057-3448cc7c3bb9?q=80&w=1200&auto=format&fit=crop',
    description: 'Bulgārija ir viens no Eiropas slēptajiem dārgumiem Melnās jūras krastā. Tā ir pazīstama ar savām plašajām, zeltainajām smilšu pludmalēm, pieejamām cenām un bagātīgo vēstures mantojumu. Neatkarīgi no tā, vai meklējat ģimenes atpūtu Saulainajā Krastā vai vēlaties izpētīt senās Nesebāras ieliņas, Bulgārija pārsteigs ar savu viesmīlību.',
    highlights: ['Zeltainas smilšu pludmales', 'Vēsturiskas vecpilsētas', 'Lieliska virtuve', 'Draudzīgas cenas'],
    cities: [{ id: '201', name: 'Burgasa', slug: 'burgasa', countryId: '2' }]
  },
  {
    id: '3',
    name: 'Kanāriju Salas',
    slug: 'kanariju-salas',
    image: 'https://images.unsplash.com/photo-1533104816931-20fa691ff6ca?q=80&w=1200&auto=format&fit=crop',
    description: 'Kanāriju salas, pazīstamas kā "mūžīgā pavasara salas", piedāvā unikālu dabas kontrastu spēli Atlantijas okeāna vidū. No Tenerifes vulkāniskajām ainavām un Teides kalna līdz Fuerteventuras baltajām smilšu kāpām un Grankanārijas daudzveidīgajai florai – katra sala ir kā mazs kontinents pats par sevi.',
    highlights: ['Vulkāniskas ainavas', 'Mūžīgā pavasara klimats', 'Sērfošana un ūdenssports', 'Unikāli dabas parki'],
    cities: [
      { id: '301', name: 'Grankanārija', slug: 'grankanarija', countryId: '3' },
      { id: '302', name: 'Tenerife', slug: 'tenerife', countryId: '3' }
    ]
  },
  {
    id: '4',
    name: 'Turcija',
    slug: 'turcija',
    image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?q=80&w=1200&auto=format&fit=crop',
    description: 'Turcija ir tilts starp Austrumiem un Rietumiem, piedāvājot nepārspējamu "viss iekļauts" servisu, siltu jūru un tūkstošiem gadu senu vēsturi. No Antālijas piekrastes tirkīzzilajiem ūdeņiem līdz Kapadokijas pasaku dūmeņiem un Stambulas grandiozumam – Turcija ir galamērķis, kurā gribas atgriezties atkal un atkal.',
    highlights: ['Labākais "viss iekļauts" serviss', 'Antīkās vēstures pieminekļi', 'Turku pirts (Hammām)', 'Tirkīza piekrastes'],
    cities: [{ id: '401', name: 'Antālija', slug: 'antalija', countryId: '4' }]
  }
];

export const CATEGORIES = [
  'Atpūtas ceļojumi',
  'Slēpošanas ceļojumi',
  'Kombinētās tūres',
  'Aktīvā atpūta',
  'Solo ceļojumi',
  'Viss iekļauts',
  'Darbatpūta',
  'Medusmēneša ceļojumi',
  'Eksotiskie ceļojumi'
];

export const SERVICES: Service[] = [
  {
    id: 's1',
    title: 'Individuālu ceļojumu maršrutu izstrāde',
    slug: 'individualu-marsrutu-izstrade',
    icon: 'fas fa-map-marked-alt',
    shortDescription: 'Unikāls ceļojuma plāns "no A līdz Z" atbilstoši jūsu interesēm un tempam.',
    fullDescription: 'Mēs ticam, ka labākie stāsti nerodas tūristu pūļos. Mūsu eksperti izveido unikālu ceļojuma plānu, kas pielāgots tieši jums – no slepeniem restorāniem, kurus zina tikai vietējie, līdz privātām ekskursijām. Mēs parūpējamies par loģistiku, lai jūs varētu baudīt mirkli.',
    value: 'Jūs iegūstat unikālu pieredzi bez stundām ilgas sēdēšanas forumos un meklētājservisos.',
    image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=1200&auto=format&fit=crop'
  },
  {
    id: 's2',
    title: 'Korporatīvo pasākumu un komandējumu plānošana',
    slug: 'korporativie-pasakumi-un-komandejumi',
    icon: 'fas fa-briefcase',
    shortDescription: 'Pilna servisa loģistika uzņēmumiem – lidojumi, viesnīcas un pasākumi.',
    fullDescription: 'Biznesa segmentam, kur laiks ir nauda. Mēs nodrošinām visu nepieciešamo jūsu komandas veiksmīgam braucienam: sākot no lidojumu rezervācijām un viesnīcām ar konferenču zālēm, līdz pat saliedēšanās pasākumiem eksotiskās vietās. Nodrošinām visus dokumentus grāmatvedībai.',
    value: 'Uzņēmuma darbinieki var fokusēties uz darbu, kamēr mēs risinām visas tehniskās detaļas.',
    image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1200&auto=format&fit=crop'
  },
  {
    id: 's3',
    title: 'Eksotisko galamērķu un ekspedīciju organizēšana',
    slug: 'eksotisko-galamerku-ekspedicijas',
    icon: 'fas fa-compass',
    shortDescription: 'Sarežģīti galamērķi ar specifiskām zināšanām un vietējiem gidiem.',
    fullDescription: 'Specializēti braucieni uz vietām, kur nepieciešamas specifiskas zināšanas: Safari Āfrikā, kalnu pārgājieni Peru vai ekspedīcijas uz Islandi. Mēs sadarbojamies ar profesionāliem vietējiem gidiem un nodrošinām visas nepieciešamās atļaujas.',
    value: 'Drošība un garantija, ka pat tālākie pasaules nostūri būs ērti un pārdomāti sasniedzami.',
    image: 'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?q=80&w=1200&auto=format&fit=crop'
  },
  {
    id: 's4',
    title: 'Pilna servisa vīzu un dokumentu atbalsts',
    slug: 'vizu-un-dokumentu-atbalsts',
    icon: 'fas fa-file-signature',
    shortDescription: 'Konsultācijas un palīdzība vīzu, ETA/ESTA un apdrošināšanas noformēšanā.',
    fullDescription: 'Mēs noņemam birokrātijas slogu no jūsu pleciem. Mūsu speciālisti palīdzēs sagatavot visus nepieciešamos dokumentus vīzu pieteikumiem, ieceļošanas atļaujām (ETA/ESTA) un piemeklēs labāko ceļojuma apdrošināšanu jūsu mieram.',
    value: 'Miers un pārliecība, ka dokumenti ir sakārtoti pareizi un pie robežas neradīsies problēmas.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=1200&auto=format&fit=crop'
  },
  {
    id: 's5',
    title: '24/7 Krīzes vadība un tūristu atbalsts',
    slug: 'krizes-vadiba-un-atbalsts',
    icon: 'fas fa-headset',
    shortDescription: 'Nepārtraukta pieejamība un operatīva palīdzība jebkurā situācijā.',
    fullDescription: 'Jūsu drošības spilvens svešā valstī. Ja reiss tiek atcelts, pazūd bagāža vai rodas neparedzētas viesnīcas situācijas, mēs operatīvi rīkojamies jūsu vietā. Mēs esam tikai viena zvana attālumā jebkurā diennakts laikā.',
    value: 'Klients nekad nejūtas pamests novārtā, jo viena zvana attālumā ir profesionālis.',
    image: 'https://images.unsplash.com/photo-1534536281715-e28d76689b4d?q=80&w=1200&auto=format&fit=crop'
  }
];

export const PACKAGES: Package[] = [
  {
    id: 'p1',
    title: 'Grezna atpūta Dubaijā',
    slug: 'grezna-atputa-dubaija',
    country: 'Apvienotie Arābu Emirāti',
    city: 'Dubaija',
    price: 1250,
    nights: 7,
    people: 2,
    categories: ['Viss iekļauts', 'Atpūtas ceļojumi'],
    hotel: {
      name: 'Atlantis The Palm',
      stars: 5,
      facilities: ['Baseins', 'SPA', 'Privātā pludmale', 'Fitnesa zāle'],
      childrenOptions: ['Bērnu klubs', 'Akvaparks'],
      renovationYear: 2021,
      location: 'Palm Jumeirah'
    },
    amenities: ['WiFi', 'Gaisa kondicionieris', 'TV'],
    mealPlan: 'Viss iekļauts',
    lastMinute: false,
    popularity: 95,
    description: 'Piedzīvojiet neaizmirstamu greznību vienā no pasaules slavenākajām viesnīcām.',
    inclusions: {
      flight: true,
      hotel: true,
      mealPlan: 'All Inclusive',
      transfer: 'Group',
      services: ['Gida pakalpojumi', 'Akvaparka apmeklējums']
    }
  },
  {
    id: 'p2',
    title: 'Saulainā Burgasa',
    slug: 'saulaina-burgasa',
    country: 'Bulgārija',
    city: 'Burgasa',
    price: 450,
    nights: 7,
    people: 2,
    categories: ['Atpūtas ceļojumi'],
    hotel: {
      name: 'Grand Hotel Pomorie',
      stars: 4,
      facilities: ['Baseins', 'SPA', 'Restorāns'],
      childrenOptions: ['Rotaļu laukums'],
      location: 'Pomorie'
    },
    amenities: ['WiFi', 'Balkons'],
    mealPlan: 'Brokastis un vakariņas',
    lastMinute: true,
    popularity: 88,
    description: 'Lieliska atpūta Melnās jūras krastā par pieejamu cenu.',
    inclusions: {
      flight: true,
      hotel: true,
      mealPlan: 'Half Board',
      transfer: 'Group',
      services: []
    }
  },
  {
    id: 'p3',
    title: 'Tenerifes pērle',
    slug: 'tenerifes-perle',
    country: 'Kanāriju Salas',
    city: 'Tenerife',
    price: 890,
    nights: 7,
    people: 2,
    categories: ['Aktīvā atpūta', 'Atpūtas ceļojumi'],
    hotel: {
      name: 'Hard Rock Hotel Tenerife',
      stars: 5,
      facilities: ['Baseins', 'Dzīvā mūzika', 'Pludmale'],
      childrenOptions: ['Bērnu animācija'],
      location: 'Adeje'
    },
    amenities: ['WiFi', 'Mini-bārs'],
    mealPlan: 'Brokastis un vakariņas',
    lastMinute: false,
    popularity: 92,
    description: 'Moderns stils un lieliska atmosfēra mūžīgā pavasara salā.',
    inclusions: {
      flight: true,
      hotel: true,
      mealPlan: 'Bed & Breakfast',
      transfer: 'Individual',
      services: ['Sveiciena dzēriens']
    }
  },
  {
    id: 'p4',
    title: 'Solo piedzīvojums Grankanārijā',
    slug: 'solo-grankanarija',
    country: 'Kanāriju Salas',
    city: 'Grankanārija',
    price: 720,
    nights: 10,
    people: 1,
    categories: ['Solo ceļojumi', 'Aktīvā atpūta'],
    hotel: {
      name: 'Lopesan Costa Meloneras',
      stars: 4,
      facilities: ['Milzu baseins', 'Kazino', 'Dārzs'],
      childrenOptions: [],
      location: 'Meloneras'
    },
    amenities: ['WiFi', 'Seifs'],
    mealPlan: 'Brokastis un vakariņas',
    lastMinute: true,
    popularity: 85,
    description: 'Ideāla vieta tiem, kas vēlas baudīt sauli un aktīvu dzīvesveidu vienatnē.',
    inclusions: {
      flight: true,
      hotel: true,
      mealPlan: 'Half Board',
      transfer: 'Group',
      services: []
    }
  },
  {
    id: 'p5',
    title: 'Maģiskā Antālija',
    slug: 'magiska-antalija-last-minute',
    country: 'Turcija',
    city: 'Antālija',
    price: 580,
    nights: 7,
    people: 2,
    categories: ['Viss iekļauts', 'Atpūtas ceļojumi'],
    hotel: {
      name: 'Delphin Imperial',
      stars: 5,
      facilities: ['Baseins', 'Privātā pludmale', 'SPA', 'Restorāni'],
      childrenOptions: ['Bērnu klubs'],
      location: 'Lara'
    },
    amenities: ['WiFi', 'Gaisa kondicionieris'],
    mealPlan: 'Viss iekļauts',
    lastMinute: true,
    popularity: 97,
    description: 'Izbaudiet Turcijas labāko servisu un kristāldzidru jūru Antālijā.',
    inclusions: {
      flight: true,
      hotel: true,
      mealPlan: 'Ultra All Inclusive',
      transfer: 'Group',
      services: ['Gida pakalpojumi']
    }
  }
];

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 'b1',
    title: '5 iemesli, kāpēc apmeklēt Dubaiju šoziem',
    slug: '5-iemesli-apmeklet-dubaiju',
    excerpt: 'Dubaija nav tikai debesskrāpji. Atklājiet tuksneša safari burvību, pasaules klases iepirkšanos un nebeidzamu sauli.',
    content: 'Dubaija ir pilsēta, kas nekad neguļ un nekad nepārstāj pārsteigt. Ziemas mēneši ir ideāls laiks, lai dotos uz Apvienotajiem Arābu Emirātiem, jo temperatūra ir patīkama gan atpūtai pludmalē, gan pilsētas apskatei. Šajā rakstā mēs apskatīsim piecus galvenos iemeslus, kāpēc Dubaijai vajadzētu būt jūsu saraksta augšgalā.',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=1200&auto=format&fit=crop',
    date: '2024. gada 15. novembris',
    category: 'Galamērķi',
    author: 'LEC Travel Eksperts'
  },
  {
    id: 'b2',
    title: 'Kā sagatavoties pirmajam kalnu slēpošanas braucienam',
    slug: 'ka-sagatavoties-sleposanai',
    excerpt: 'Plānojat savu pirmo braucienu uz Alpiem? Mūsu ceļvedis palīdzēs jums izvēlēties pareizo inventāru un galamērķi.',
    content: 'Slēpošana ir aizraujošs veids, kā pavadīt ziemas brīvdienas, taču iesācējiem tā var šķist biedējoša. No pareizā apģērba izvēles līdz pirmajām stundām uz nogāzes – mēs esam here, lai palīdzētu. Svarīgākais ir nebaidīties un izvēlēties kūrortu, kas ir draudzīgs jaunpienācējiem.',
    image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?q=80&w=1200&auto=format&fit=crop',
    date: '2024. gada 2. decembris',
    category: 'Padomi',
    author: 'Anna Kalniņa'
  },
  {
    id: 'b3',
    title: 'Eksotiskā Bali: No džungļiem līdz okeānam',
    slug: 'eksotiska-bali-celvedis',
    excerpt: 'Bali ir sala, kurā mīt dievi. Uzziniet, kuras vietas ir obligāti jāredz un kā izbaudīt autentisko salas kultūru.',
    content: 'Indonēzijas pērle Bali piedāvā unikālu dabas un garīguma kombināciju. Neatkarīgi no tā, vai meklējat mieru Ubuda rīsu terasēs vai ballītes Seminyak pludmalēs, Bali atradīsiet kaut ko sev. Mēs dalāmies ar mūsu mīļākajām vietām un slepenajiem dārgakmeņiem, kurus tūristi bieži palaiž garām.',
    image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?q=80&w=1200&auto=format&fit=crop',
    date: '2024. gada 20. decembris',
    category: 'Eksotika',
    author: 'Mārcis Bērziņš'
  }
];